import { Business, Favourites, FollowUp, Holidays, Ideas, Important, Orgenization } from "../../../utils/Constant";

export let sideBarData =[
    {value:"2",tittle:Orgenization},
    {value:"3",tittle:FollowUp},
    {value:"4",tittle:Favourites},
    {value:"5",tittle:Ideas},
    {value:"6",tittle:Important},
    {value:"7",tittle:Business},
    {value:"8",tittle:Holidays},
]
export const organizationList = [
    {
      id: "1",
      activeTab: "1",
      img: "user/user.png",
      name: "Mark Jecno",
      email: 'MARK JENCO EMAIL',
      gender: "Male",
    },
    {
      id: "2",
      activeTab: "2",
      img: "user/3.jpg",
      name: "Jason Borne",
      email: "jasonb@gmail.com",
      gender: "Male",
    },
    {
      id: "3",
      activeTab: "3",
      img: "user/4.jpg",
      name: "Sarah Loren",
      email: "barnes@gmail.com",
      gender: "Female",
    },
    {
      id: "4",
      activeTab: "4",
      img: "user/10.jpg",
      name: "Andew Jon",
      email: "andewjon@gmail.com",
      gender: "Female",
    },
  ];
  